import styled from 'styled-components';

export const LegalBioModalUploadTextStyles = styled.div`
  margin-top: 1rem;
`;
